import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalOverlayFn = /* @__PURE__ */ createRecipe('modal-overlay', {}, [])

const modalOverlayVariantMap = {}

const modalOverlayVariantKeys = Object.keys(modalOverlayVariantMap)

export const modalOverlay = /* @__PURE__ */ Object.assign(memo(modalOverlayFn.recipeFn), {
  __recipe__: true,
  __name__: 'modalOverlay',
  __getCompoundVariantCss__: modalOverlayFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: modalOverlayVariantKeys,
  variantMap: modalOverlayVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalOverlayVariantKeys)
  },
  getVariantProps: modalOverlayFn.getVariantProps,
})